import type { GalleryItem } from '../types/content';
import { projects } from '../data/content';

export function GalleryMetadata({ item }: { item: GalleryItem }) {
  const project = projects.find((project) => project.slug === item.media.relatedProject);
  return <span className="gallery-metadata">
    <span>Projeto: {project?.title || item.title}</span>
    {item.media.credit && <span>Crédito: {item.media.credit}</span>}
  </span>;
}
